// Services
import ApiServiceV2 from 'services/apiService/apiServiceV2';

const usePaymentLineApi = () => ({
	getLineItems: () =>
		ApiServiceV2.get({
			url: '/payments_lines_items',
		}),

	createLine: data =>
		ApiServiceV2.post({
			url: '/payments_lines',
			data,
		}),

	createLineItem: data =>
		ApiServiceV2.post({
			url: '/payments_lines_items',
			data,
		}),

	updateLineItem: data =>
		ApiServiceV2.put({
			url: '/payments_lines_items',
			data,
		}),

	getCoins: () =>
		ApiServiceV2.get({
			url: '/coins',
		}),
});

export default usePaymentLineApi;
